import * as React from 'react'
import Select from 'react-select'
import { CurrentUserType } from '../../CommonContext'

interface Department {
  id: number
  title: string
}

interface WeeklistDefaultDepartmentsSelectProps {
  availableDepartments: Department[]
  currentUser: CurrentUserType
  name: string
  inputId: string
  label?: string
}

export default function WeeklistDefaultDepartmentsSelect({
  availableDepartments,
  currentUser,
  name,
  inputId,
  label = 'Default afdelinger for Ugeliste:',
}: WeeklistDefaultDepartmentsSelectProps) {
  const options = availableDepartments.map(department => ({
    value: department.id,
    label: department.title,
  }))

  const defaultValue = currentUser.weeklist_default_department_ids
    ? currentUser.weeklist_default_department_ids.map(id => {
        const department = availableDepartments.find(d => d.id.toString(10) === id)
        return department
          ? { value: department.id, label: department.title }
          : null
      }).filter(Boolean)
    : []

  return (
    <div className="form-group">
      <label htmlFor={inputId}>{label}</label>
      <Select
        isMulti
        name={name}
        inputId={inputId}
        options={options}
        defaultValue={defaultValue}
        className="basic-multi-select"
        classNamePrefix="select"
      />
      <small className="form-text text-muted">
        Disse afdelinger vil blive anvendt som standard, når du åbner Ugeliste.
      </small>
    </div>
  )
}
